import axios, { AxiosPromise, Canceler, CancelTokenStatic } from 'axios';
import { IGlCode } from '../../../@types/model/masterData/glCode/glCode';
import { IGlCodeUpsert } from '../../../@types/model/masterData/glCode/glCodeUpsert';

export default class GlCodeHttpService {
    private static readonly CancelToken : CancelTokenStatic = axios.CancelToken;
    /**
     * Allows you to cancel list request
     */
    public static cancelGetList ?: Canceler;

    public static getList(divisionIds : Array<number>) : AxiosPromise<Array<IGlCode>> {
        if (this.cancelGetList) {
            this.cancelGetList('GET Canceled');
            this.cancelGetList = undefined;
        }

        return axios.get(`${API_URL}/v1/MasterData/GlCode/GetList`, {
            params: {
                divisionIds
            },
            paramsSerializer: {
                indexes: null
            },
            cancelToken: new this.CancelToken((c) => {
                this.cancelGetList = c;
            }),
        });
    }

    public static upsert = (upsert : IGlCodeUpsert, type : 'Add' | 'Edit') : AxiosPromise<IGlCode> => {
        return axios.post(`${API_URL}/v1/MasterData/GlCode/${type}`, upsert);
    }

    public static delete = (id : number) : AxiosPromise<void> => {
        return axios.delete(`${API_URL}/v1/MasterData/GlCode/Delete`, {
            params: { id },
        });
    }
}